import { Link } from 'react-router-dom';

function DashboardActiveMainStrategyFuelSystem({value, userData}) {
    return (
        <>
            {value["session-type"] === 2 &&
            <>
                <div className="relative space-y-3">
                    <h2 className="text-xs font-bold uppercase text-[#92adc9] tracking-wider">Fuel Strategy <span className="text-[9px] text-[#92adc9] tracking-wider">By Simone Manzoni</span></h2>
                    {value["completed-laps"] === 0 ? 
                        <>
                            <div className="grid grid-cols-2 gap-3 relative">
                                <div className="rounded-lg bg-[#233648]/30 p-2 border border-[#324d67]/30">
                                    <span className="text-[9px] uppercase text-[#92adc9]">Needed</span>
                                    <p className="text-lg font-bold">{userData.subscription === "pro" ? value["fuel-needed"].toFixed(1) : "0.0"} L</p>
                                </div>
                                <div className="rounded-lg bg-[#233648]/30 p-2 border border-[#324d67]/30">
                                    <span className="text-[9px] uppercase text-[#92adc9]">Safe</span>
                                    <p className="text-lg font-bold text-acc-yellow">{userData.subscription === "pro" ? value["fuel-safe"].toFixed(1) : "0.0"}</p>
                                </div>

                                {userData.subscription !== "pro" && 
                                    <div class="absolute w-full h-full inset-0 flex items-center justify-center">
                                        <div class="flex justify-center flex-col items-center bg-[#1c2a38b3] h-full backdrop-blur-sm border border-primary/40 rounded-2xl p-8 w-full text-center shadow-2xl ring-1 ring-white/10">
                                            <div class="inline-flex items-center justify-center size-14 rounded-full bg-primary/20 mb-[9px] w-[fit-content] aspect-square">
                                                <span class="material-symbols-outlined text-primary text-[17px]">lock</span>
                                            </div>
                                            <Link to="/subscription-plans">
                                            <button class="w-full bg-primary hover:bg-primary/90 text-white font-bold py-3.5 px-6 rounded-lg transition-all transform hover:scale-[1.02] active:scale-95 shadow-lg shadow-primary/20 uppercase tracking-widest text-[10px] p-[4px 15px]">
                                                Upgrade to Pro
                                            </button>
                                            </Link>
                                        </div>
                                    </div>
                                }
                            </div>
                        </>
                    :
                        <>
                        <div className="grid grid-cols-2 gap-3 relative">
                            <div className="rounded-lg bg-[#233648]/30 p-2 border border-[#324d67]/30">
                                <span className="text-[9px] uppercase text-[#92adc9]">Needed</span>
                                <p className="text-lg font-bold">{userData.subscription === "pro" ? value["fuel-needed"].toFixed(1) : "0.0"} L</p>
                            </div>

                            <div className="rounded-lg bg-[#233648]/30 p-2 border border-[#324d67]/30">
                                <span className="text-[9px] uppercase text-[#92adc9]">Total Laps Estimated</span>
                                <p className="text-lg font-bold text-acc-yellow">~{userData.subscription === "pro" ? value["raw-laps"].toFixed(1) : "0.0"}</p>
                            </div>
                            <div className="col-span-2 rounded-lg bg-[#233648]/30 p-2 border border-[#324d67]/30">
                                <div className="flex justify-between text-[9px] uppercase text-[#92adc9] mb-1">
                                    <span>Fuel delta</span>
                                    <span className="text-white">{userData.subscription === "pro" ? value["fuel-delta"].toFixed(1) : "0.0"} L</span>
                                </div>
                                <div className="w-full bg-[#111a22] h-1.5 rounded-full overflow-hidden flex">
                                    <div className="relative w-full h-1.5 bg-gray-800 rounded-full flex items-center overflow-hidden">
                                        <div className="absolute left-1/2 w-0.5 h-full bg-gray-500 z-10"></div>

                                        <div className="absolute right-1/2 h-full flex justify-end overflow-hidden transition-all" style={{ width: `${value["fuel-delta"] < 0 ? Math.abs((value["fuel-delta"]/value["fuel-x-lap"])*50) : 0}%`, borderRadius: "20px 0 0 20px" }}>
                                            <div className="h-full w-full bg-acc-red transition-all duration-75 ease-out"></div>
                                        </div>

                                        <div className="absolute left-1/2 h-full flex justify-start rounded-full overflow-hidden transition-all" style={{ width: `${value["fuel-delta"] > 0 ? ((value["fuel-delta"]/value["fuel-x-lap"])*50) : 0}%`, borderRadius: "0 20px 20px 0" }}>
                                            <div className="h-full w-full bg-acc-green transition-all duration-75 ease-out"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {userData.subscription !== "pro" && 
                                <div class="absolute w-full h-full inset-0 flex items-center justify-center">
                                    <div class="flex justify-center flex-col items-center bg-[#1c2a38b3] h-full backdrop-blur-sm border border-primary/40 rounded-2xl p-8 w-full text-center shadow-2xl ring-1 ring-white/10">
                                        <div class="inline-flex items-center justify-center size-14 rounded-full bg-primary/20 mb-[9px] w-[fit-content] aspect-square">
                                            <span class="material-symbols-outlined text-primary text-[17px]">lock</span>
                                        </div>
                                        <Link to="/subscription-plans">
                                        <button class="w-full bg-primary hover:bg-primary/90 text-white font-bold py-3.5 px-6 rounded-lg transition-all transform hover:scale-[1.02] active:scale-95 shadow-lg shadow-primary/20 uppercase tracking-widest text-[10px] p-[4px 15px]">
                                            Upgrade to Pro
                                        </button>
                                        </Link>
                                    </div>
                                </div>
                            }
                        </div>
                        </>
                    }
                </div>
            </>
            }
        </>
    );
}

export default DashboardActiveMainStrategyFuelSystem;